require('./bootstrap');
require('@tailwindcss/forms')

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3'
import moment from "moment";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    progress: {
        color: '#4B5563',
    },
    setup({el, App, props, plugin}) {
        return createApp({render: () => h(App, props)})
            .use(plugin)
            .mixin({
                methods: {
                    route, // route() function comes from @routes blade directive in app.blade.php, defined by the package https://github.com/tighten/ziggy#route-function
                    formatDate: (dateTimeString) => {
                        if (dateTimeString) {
                            return moment(String(dateTimeString)).format('ll');
                        }
                    }
                }
            })
            .mount(el);
    },
});
